export default data => data;
